export default "/images/show_sys_logo-dark.svg?7a3be3141f0b36ef5a49198454cda873";